export interface Login {
    userDbId: number;
    username: string,
    password: string,
    email: string,
    agentName: String,
    roles:number,
    roleName:string,
    authToken:string,
    rememberMe:boolean
}

export function defaultLoginValues(): Login {
    return <Login>{
        userDbId: 0,
        username: '',
        password: '',
        email: '',
        agentName: '',
        roles:0,
        roleName:'',
        authToken:'',
        rememberMe:false
    }
}
